import React, { FC } from "react";
import { StyledTableCell } from "../../../ui-components/StyledTables";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { OrgColumn } from "../../../interfaces/SuperAdmin/Pages/iDataOrganizacion";
import { UserOrgColumn } from "../../../interfaces/SuperAdmin/Pages/iDataUserOrganization";

interface Props {
  label: string;
  column: OrgColumn | UserOrgColumn;
  handleSort: any
  orderBy: OrgColumn | UserOrgColumn | null;
  orderDirection: "asc" | "desc";
}

const SortedHeaderCell: FC<Props> = ({
  label,
  column,
  handleSort,
  orderBy,
  orderDirection,
}) => {
  return (
    <StyledTableCell>
      <button
        onClick={() => handleSort(column)}
        style={{ cursor: "pointer", background: "none", border: "none", padding: 0, font: "inherit", color: "inherit" }}
      >
        {label}{" "}
        {orderBy === column &&
          (orderDirection === "asc" ? (
            <KeyboardArrowUpIcon />
          ) : (
            <KeyboardArrowDownIcon />
          ))}
      </button>
    </StyledTableCell>
  );
};

export default SortedHeaderCell;
